import ReactDOM from "react-dom";
import { useState, useEffect, ReactNode } from "react";

type PortalProps = {
  children: ReactNode; selector: string
}

const Portal = ({ children, selector }: PortalProps) => {
  const [element, setElement] = useState<Element | null>(null);

  useEffect(() => {
    setElement(document.querySelector(selector));
  }, [selector]);

  if (!element) {
    return null;
  }

  return ReactDOM.createPortal(children, element);
};

export default Portal;
